/* eslint-disable no-case-declarations */
import { map, get, isNumber } from 'lodash';
import numeral from 'numeral';

numeral.nullFormat('--');
export const segmentFilters = [
  {
    section: 'Demographics',
    id: 'age',
    title: 'Age Range',
    label: 'Select Age Range',
    benchmarkLabel: 'Select Age Range'
  },
  {
    section: 'Demographics',
    id: 'gender',
    title: 'Gender',
    label: 'Select Gender',
    benchmarkLabel: 'Select Gender'
  },
  {
    section: 'Demographics',
    id: 'country',
    title: 'Country',
    label: 'Select Country',
    benchmarkLabel: 'Select Country'
  },
  {
    section: 'Date',
    id: 'date',
    title: 'Date',
    label: 'Select Date',
    benchmarkLabel: 'Select Date'
  },
  {
    section: 'Demographics',
    id: 'panel',
    description: 'Sample balance users. US only.',
    label: 'Panel',
    benchmarkLabel: 'Panel',
    options: [
      { value: 'Balanced', label: 'Balanced' },
      { value: 'Total', label: 'Total' }
    ],
    title: 'Panel'
  }
];

export const showContentFilters = [
  {
    section: 'Content',
    id: 'show',
    title: 'Show',
    label: 'Select Show',
    benchmarkLabel: 'Select Show',
    allowBulk: true
  },
  {
    section: 'Content',
    id: 'network',
    title: 'Network',
    label: 'Select Network',
    benchmarkLabel: 'Select Network'
  },
  {
    section: 'Content',
    id: 'genre',
    title: 'Genre',
    label: 'Select Genre',
    benchmarkLabel: 'Select Genre'
  },
  {
    section: 'Content',
    id: 'status',
    isMulti: true,
    title: 'Status',
    label: 'Select Status',
    benchmarkLabel: 'Select Status'
  },
  {
    section: 'Content',
    id: 'runtime',
    isMulti: true,
    title: 'Runtime',
    label: 'Select Runtime Type',
    benchmarkLabel: 'Select Runtime Type'
  },
  {
    section: 'Content',
    id: 'originating_country',
    title: 'Originating Country',
    label: 'Select Originating Country',
    benchmarkLabel: 'Select Originating Country'
  },
  {
    section: 'Content',
    id: 'first_release_date',
    title: 'Release Date',
    label: 'Select Release Date',
    benchmarkLabel: 'Select Release Date'
  },
  {
    section: 'Content',
    id: 'tier',
    title: 'Followers',
    isMulti: true,
    label: 'Select Follow Count',
    benchmarkLabel: 'Select Follow Count',
    options: [
      { label: '500-1k', value: 0.5 },
      { label: '1k-10k', value: 1 },
      { label: '10k-50k', value: 10 },
      { label: '50k-100k', value: 50 },
      { label: '100k-500k', value: 100 },
      { label: '>500k', value: 500 }
    ]
  }
];

export const movieContentFilters = [
  {
    section: 'Content',
    id: 'movie',
    title: 'Movie',
    label: 'Select Movie',
    benchmarkLabel: 'Select Movie',
    allowBulk: true
  },
  {
    section: 'Content',
    id: 'studio',
    title: 'Studio',
    label: 'Select Studio',
    benchmarkLabel: 'Select Studio'
  },
  {
    section: 'Content',
    id: 'genre',
    title: 'Genre',
    label: 'Select Genre',
    benchmarkLabel: 'Select Genre'
  },
  {
    section: 'Content',
    id: 'runtime',
    isMulti: true,
    title: 'Runtime',
    label: 'Select Runtime Type',
    benchmarkLabel: 'Select Runtime Type'
  },
  {
    section: 'Content',
    id: 'first_release_date',
    title: 'Release Date',
    label: 'Select Release Date',
    benchmarkLabel: 'Select Release Date'
  },
  {
    section: 'Content',
    id: 'tier',
    title: 'Followers',
    isMulti: true,
    label: 'Select Follow Count',
    benchmarkLabel: 'Select Follow Count',
    options: [
      { label: '500-1k', value: 0.5 },
      { label: '1k-10k', value: 1 },
      { label: '10k-50k', value: 10 },
      { label: '50k-100k', value: 50 },
      { label: '100k-500k', value: 100 },
      { label: '>500k', value: 500 }
    ]
  }
];

export const formatFilters = (config, contentType) => {
  return map(
    [
      ...(contentType === 'series' ? showContentFilters : movieContentFilters),
      ...segmentFilters
    ],
    filter => {
      const { value, ...configExceptValue } = get(config, [filter.id], {});

      return {
        ...filter,
        ...configExceptValue,
        isMulti: filter.isMulti || configExceptValue.isMulti
      };
    }
  );
};

export const benchmarkTooltipDeactivated = () => {
  return localStorage.getItem('showBenchmarkTooltip');
};

export const calcPercentVariance = (title, benchmark) => {
  const titleNumber = title && Number(title);
  const benchmarkNumber = benchmark && Number(benchmark);
  let percentVariance;
  if (isNumber(titleNumber) && isNumber(benchmarkNumber) && benchmarkNumber !== 0) {
    percentVariance = ((titleNumber - benchmarkNumber) / benchmarkNumber) * 100;
  }
  return  percentVariance;
};

export const buildMetricObj = (data, page, metric, label, tooltip, format) => {
  let top = get(data, [`${page}Top`, metric], null);
  let bottom = get(data, [`${page}Bottom`, metric], null);
  const variance = calcPercentVariance(top, bottom);

  if (format) {
    top = numeral(top).format(format);
    bottom = numeral(bottom).format(format);
  }

  return {
    top,
    bottom,
    label,
    variance,
    tooltip
  };
};

export const titleInitialState = {
  movieReportAnticipationTop: null,
  movieReportAnticipationBottom: null,
  movieReportViewershipTop: null,
  movieReportViewershipBottom: null,
  movieReportEngagementTop: null,
  movieReportEngagementBottom: null,
  tier: null,
  movies: null,
  movieId: null,
  apiRequestTop: null,
  apiRequestBottom: null,
  loadingTop: false,
  loadingBottom: false
};

export const titleReducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE':
      if (action.apiRequest !== state.apiRequest) {
        return state;
      }
      const keys = Object.keys(action.value);
      const final = {};
      keys.forEach(k => {
        if (!state[k]) {
          final[k] = action.value[k];
        } else {
          final[k] = { ...state[k], ...action.value[k] };
        }
      });
      return { ...state, ...final };
    case 'INITIATE_REQUEST':
      return {
        ...state,
        apiRequest: action.apiRequest,
        [action.topData ? 'loadingTop' : 'loadingBottom']: true
      };
    case 'RESET':
      if (action.topData) {
        return {
          ...state,
          movieReportAnticipationTop: null,
          movieReportViewershipTop: null,
          movieReportEngagementTop: null,
          apiRequestTop: null
        };
      }

      return {
        ...state,
        movieReportAnticipationBottom: null,
        movieReportViewershipBottom: null,
        movieReportEngagementBottom: null,
        apiRequestBottom: null
      };
    case 'LOADING_DONE':
      return {
        ...state,
        [action.topData ? 'loadingTop' : 'loadingBottom']: false
      };
    case 'ERROR':
      return {
        ...state,
        movieReportAnticipationTop: null,
        movieReportViewershipTop: null,
        movieReportEngagementTop: null,
        apiRequestTop: null
      };
    default:
      throw new Error();
  }
};

export const showInitialState = {
  showReportAnticipationTop: null,
  showReportAnticipationBottom: null,
  showReportViewershipTop: null,
  showReportViewershipBottom: null,
  showReportEngagementTop: null,
  showReportEngagementBottom: null,
  tier: null,
  shows: null,
  showId: null,
  apiRequestTop: null,
  apiRequestBottom: null,
  loadingTop: false,
  loadingBottom: false
};

export const showReducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE':
      if (action.apiRequest !== state.apiRequest) {
        return state;
      }
      const keys = Object.keys(action.value);
      const final = {};
      keys.forEach(k => {
        if (!state[k]) {
          final[k] = action.value[k];
        } else {
          final[k] = { ...state[k], ...action.value[k] };
        }
      });
      return { ...state, ...final };
    case 'INITIATE_REQUEST':
      return {
        ...state,
        apiRequest: action.apiRequest,
        [action.topData ? 'loadingTop' : 'loadingBottom']: true
      };
    case 'RESET':
      if (action.topData) {
        return {
          ...state,
          showReportAnticipationTop: null,
          showReportViewershipTop: null,
          showReportEngagementTop: null,
          apiRequestTop: null
        };
      }

      return {
        ...state,
        showReportAnticipationBottom: null,
        showReportViewershipBottom: null,
        showReportEngagementBottom: null,
        apiRequestBottom: null
      };
    case 'LOADING_DONE':
      return {
        ...state,
        [action.topData ? 'loadingTop' : 'loadingBottom']: false
      };
    case 'ERROR':
      return {
        ...state,
        showReportAnticipationTop: null,
        showReportViewershipTop: null,
        showReportEngagementTop: null,
        apiRequestTop: null
      };
    default:
      throw new Error();
  }
};

export default {
  formatFilters,
  segmentFilters,
  benchmarkTooltipDeactivated,
  calcPercentVariance,
  buildMetricObj,
  showInitialState,
  showReducer
};
